export const removeLastSlash = (string_: string): string => (string_.endsWith('/') ? string_.slice(0, -1) : string_)
